import React, { Suspense, lazy } from "react";
import PropTypes from "prop-types";
import { Route, Switch } from "react-router-dom";
import AdvisorRouter from "./advisor";
import withAuth from "../utilities/withAuth";
const ConfiguratorRouter = lazy(() => import("./configurator"));

class AppRouter extends React.Component {
  static propTypes = {
    database: PropTypes.object.isRequired
  };

  render() {
    const WrappedConfiguratorRouter = () => {
      return <ConfiguratorRouter database={this.props.database} />;
    };

    const WrappedAdvisorRouter = () => {
      return <AdvisorRouter database={this.props.database} />;
    };

    return (
      <Suspense fallback={<div style={{ padding: "30px" }}>Loading...</div>}>
        <Switch>
          <Route path="/config/*" component={withAuth(WrappedConfiguratorRouter)} />
          <Route path="/" component={WrappedAdvisorRouter} />
        </Switch>
      </Suspense>
    );
  }
}

export default AppRouter;
